// extracted by mini-css-extract-plugin
export default {"aiFeedbackRate":"aiFeedbackRate_aiFeedbackRate__DQw7M","aiFeedbackRateButton":"aiFeedbackRate_aiFeedbackRateButton__yTnKL"};